import ApiService from '@/lib/api';
import { GetStaticProps } from 'next';
import MainLayout from '../../layouts/MainLayout';
import ServiceList from '@/components/Services/ServiceList';

export const getStaticProps: GetStaticProps = async ({ preview = false }) => {
  const apiService = new ApiService();
  const [data, menuData, { bottomCta = null, footer }] = await Promise.all([
    apiService.getServicePage(preview),
    apiService.getMenuData(),
    apiService.getMiscData(),
  ]);
  return {
    props: {
      ...data,
      bottomCta,
      menuData,
      footer,
    },
    revalidate: 3600,
  };
};

const CulturePage = ({ heading, metaDescription, metaTitle, services = [], menuData, footer, bottomCta }) => {
  const ogUrl = 'https://foxbox.com/services';

  return (
    <MainLayout
      ogUrl={ogUrl}
      bgWhite={true}
      navIsFixed={false}
      navIsDark={true}
      metaTitle={metaTitle}
      menuData={menuData}
      footer={footer}
      metaDescription={metaDescription}
    >
      <ServiceList heading={heading} services={services} bottomCta={bottomCta} />
    </MainLayout>
  );
};

export default CulturePage;
